/// <reference path="../../../app.d.ts"/>
/// <reference path="../../../../../../shared/utils/View.ts"/>
import { User } from '../../../../../../shared/models/api/User/User';

import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppViewService } from '../../services/AppViewService';
import { AppRouterService } from '../../services/AppRouterService';
import { CorrectionResponseApi } from '../../models/CorrectionResponseApi';
import { AppUtils } from '../../../../../../shared/utils/index';

export class SuccessController implements StepController {
	private readonly $ctx: JQuery;
	private readonly responseData: CorrectionResponseApi;
	private readonly options: BasicAppOptions<FuelPricesUserFeedbackAppDefinition>;
	private readonly appViewService: AppViewService;
	private readonly parent: AppController;
	private readonly user: User;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly applicationRouter: AppRouterService;

	constructor(parent: AppController, options: BasicAppOptions<FuelPricesUserFeedbackAppDefinition>, user: User, loader: BasicLoader<FuelPricesUserFeedbackAppDefinition>, successResponse: CorrectionResponseApi) {
		this.parent = parent;
		this.options = options;
		this.user = user;
		this.responseData = successResponse;
		this.$ctx = $(this.options.$ctx);

		this.appPersistenceService = new AppPersistenceService(options);
		this.appViewService = new AppViewService(parent, options, loader);
		this.applicationRouter = new AppRouterService(options);
	}

	public start(): void {
		const viewConfig = {
			data: this.getViewOptions(),
			templateurl: this.options.app.currenttemplate.templateurl,
			campaignurls: this.options.app.campaignurls,
			parent: this,
			$ctx: this.$ctx,
			options: this.options,
			callback: this.afterRenderApp
		};
		this.appViewService.render(viewConfig);
	}

	/**
	 * returns view options for the page.
	 * only variables defined in here are available in the view to use with handlebars.
	 */
	private getViewOptions(): { [key: string]: any } {
		const formModel = this.appPersistenceService.getFormModelFromStore();

		return {
			User: this.user,
			Form: formModel,
			Repsonse: this.responseData,
			nexturl: this.applicationRouter.PriceDetailsUrl || this.options.app.nexturl || ''
		};
	}

	public afterRenderApp(): void {
		AppUtils.Helper.scheduleTask(() => {
			T.Utils.Tracking.pushKameleoonData();
		}, 'background');
		this.parent.afterRenderApp();
		this.appPersistenceService.clearApplicationSession();
		AppUtils.View.stopLoader();
		AppUtils.View.scrollTop();
	}
}
